<template lang="pug">
  iframe(width="100%" height="800" :src="dashboardUrl" frameborder="0" style="border:0" allowfullscreen)
</template>
<script>

export default {
  data() {
    return {
      dashboardUrl: ''
    };
  },
  created() {
    this.fetchDashboardUrl();
  },
  methods: {
    async fetchDashboardUrl() {
      let route = this.$store.state.URLs.apiPartner + '/dashboardUrl'
      let response = await this.axios.get(route, {
        headers: {
          'X-Line-Biz-Session': localStorage.getItem(this.$store.state.storageKeys.token)
        }
      });
      this.dashboardUrl = response.data.url;
    }
  }
};
</script>
